module.exports = __webpack_public_path__ + "img/facebook_logo.043d590d.svg";